import { EVIDENCE_EFFECT_WORDS } from '../model/evidenceLabels'
import type { EvidenceVm, HitVm } from '../model/types'

/** Строка «Артикул … · Штрихкод …» под названием товара. */
export const metaOf = (hit: HitVm): string => `Артикул ${hit.sku ?? '—'} · Штрихкод ${hit.barcode ?? '—'}`

/** Сколько вариантов показывается рядом: серия шире четырёх сравнению не помогает, остальные остаются в списке ниже. */
export const MAX_VARIANTS = 4

/** Довод проверки по фото у позиции (RP-FB77 П4); проверки не было — `undefined`. */
export const judgeOf = (hit: HitVm): EvidenceVm | undefined => (hit.evidence ?? []).find((item) => item.kind === 'judge')

/** Итог проверки словами для строки списка: «модель уверена: на снимке этот товар»; без пояснения — слово влияния. */
export const judgeWords = (judge: EvidenceVm): string => judge.note ?? EVIDENCE_EFFECT_WORDS[judge.effect]
